import { toRupiah } from "../../../../../../helpers/common"


const PriceCell = ({ price }) => <p className="mb-0">{toRupiah(price)}</p>

export default PriceCell